package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.repository.RealtimeConnectionRepository
import kotlinx.coroutines.flow.Flow

class ObserveRealtimeReconnectionsUseCase(
    private val realtimeConnectionRepository: RealtimeConnectionRepository
) {
    operator fun invoke(): Flow<Unit> {
        return realtimeConnectionRepository.observeReconnections()
    }
}
